import { useState } from "react";
import { useNavigate } from "react-router";
import LayoutHeader from "../../layout/LayoutHeader";

const LoginAgency = () => {
    const [step, setStep] = useState(0);
    const [type, setType] = useState('');
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [editData, setEditData] = useState({ date: '', city: '', venue: '' });
    const navigate = useNavigate();

    const agencies = [
        { name: 'Wasserman', description: 'Connect to Wasserman Music agency' },
        { name: 'UTA', description: 'United Talent Agency integration' },
        { name: 'CAA', description: 'Creative Artists Agency portal' },
        { name: 'WME', description: 'William Morris Endeavor access' }
    ];

    const handleAgencySelect = (agencyName) => {
        setType(agencyName);
        setStep(1);
    };

    const handleLogin = () => {
        if (loginData.email && loginData.password) {
        setStep(2);
        } else {
            alert('Please enter both email and password');
        }
    };

    const handleSave = () => {
        if (editData.date && editData.city && editData.venue) {
            alert('Tour date saved successfully!');
            navigate('/bookings');
        } else {
            alert('Please fill in all fields');
        }
    };

    return (
        <LayoutHeader>
            <div className="flex justify-center w-full">
                <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
                    {/* Header */}
                    <div className="px-4 my-[50px] flex w-full justify-between items-center">
                        <p className="text-white text-[12px]">Login with Agency</p>
                        <div className="flex items-center gap-4">
                            {/* Navigation Buttons */}
                            <span 
                                className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                onClick={() => navigate('/bookings/view-all')}
                            >
                                View
                            </span>
                            
                            <span 
                                className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                onClick={() => navigate('/bookings/manual-add')}
                            >
                                Manual Add
                            </span>
                            
                        <span className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" onClick={() => navigate(-1)}>Go back</span>
                        </div>
                    </div>

                    <div className="w-full px-4 flex-1 overflow-y-auto">
                        {step === 0 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Choose your agency</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Select your booking agency to import tour data</p>
                                </div>

                                <div className="space-y-4">
                                    {agencies.map((agency, index) => (
                                        <div 
                                            key={index}
                                            className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all cursor-pointer"
                                            onClick={() => handleAgencySelect(agency.name)}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-12 h-12 bg-[rgba(255,255,0,0.2)] rounded-lg flex items-center justify-center">
                                                        <svg className="w-6 h-6 text-[#FFFF00]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h2M7 16h6M7 8h6" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        <h3 className="text-white text-[12px] font-semibold mb-1">
                                                            {agency.name}
                                                        </h3>
                                                        <p className="text-[rgba(255,255,255,0.7)] text-[10px]">
                                                            {agency.description}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="w-3 h-3 rounded-full border-2 border-[#FFFF00]" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {step === 1 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Log in to {type}</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Enter your {type} credentials to access your bookings</p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Email Address
                                        </label>
                                        <input
                                            type="email"
                                            value={loginData.email}
                                            onChange={(e) => setLoginData({
                                                ...loginData,
                                                email: e.target.value
                                            })}
                                            placeholder="Enter your email"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                                    </div>

                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Password
                                        </label>
                                        <input
                                            type="password"
                                            value={loginData.password}
                                            onChange={(e) => setLoginData({
                                                ...loginData,
                                                password: e.target.value
                                            })}
                                            placeholder="Enter your password"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                                    </div>
                                </div>

                                <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                    <button
                                        onClick={handleLogin}
                                        className="w-full bg-[#FFFF00] text-black text-[12px] font-semibold py-3 rounded-lg hover:bg-[rgba(255,255,0,0.9)] transition-all"
                                    >
                                        Log In to {type}
                                    </button>
                                </div>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="flex flex-col">
                                <div className="mb-6">
                                    <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Edit Tour Dates</span>
                                    <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Update your tour information from {type}</p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Performance Date
                                        </label>
                                        <input
                                            type="date"
                                            value={editData.date}
                                            onChange={(e) => setEditData({
                                                ...editData,
                                                date: e.target.value
                                            })}
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                    </div>

                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            City/State
                                        </label>
                                        <input
                                            type="text"
                                            value={editData.city}
                                            onChange={(e) => setEditData({
                                                ...editData,
                                                city: e.target.value
                                            })}
                                            placeholder="Enter city and state"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                    </div>

                                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                        <label className="block text-white text-[12px] font-semibold mb-2">
                                            Venue
                                        </label>
                                        <input
                                            type="text"
                                            value={editData.venue}
                                            onChange={(e) => setEditData({
                                                ...editData,
                                                venue: e.target.value
                                            })}
                                            placeholder="Enter venue name"
                                            className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                        />
                    </div>
                    </div>

                                <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#FFFF00] hover:bg-[rgba(255,255,0,0.05)] transition-all">
                                    <button
                                        onClick={handleSave}
                                        className="w-full bg-[#FFFF00] text-black text-[12px] font-semibold py-3 rounded-lg hover:bg-[rgba(255,255,0,0.9)] transition-all"
                                    >
                                        Save Tour Date
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Help Text */}
                        <div className="mt-6 mb-4">
                            <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                                {step === 0 && (
                                    <>
                                        <p>Connect your booking agency account to automatically import tour data.</p>
                                        <p>This will sync your existing bookings and tour information.</p>
                                    </>
                                )}
                                {step === 1 && (
                                    <>
                                        <p>Use your existing {type} account credentials.</p>
                                        <p>Your login information is encrypted and secure.</p>
                                    </>
                                )}
                                {step === 2 && (
                                    <>
                                        <p>Review and edit tour information imported from {type}.</p>
                                        <p>You can modify these details before saving to your account.</p>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        </LayoutHeader>
    );
};

export default LoginAgency;
